export enum ErrorCode {
  STUDY_NOT_RECRUITING = 'STUDY_NOT_RECRUITING',
  FORM_TIME_TRAVEL_ERROR = 'FORM_TIME_TRAVEL_ERROR'
}
